<template>
  <div>
    <!-- 各セクションのid（about / charm / instagram / movie / media / interview）はページ内アンカー。
        about / charm / instagram は MenuBar、movie は DrawerMenu、media は外部リンク・ブックマークから
        参照される（repo内参照が無くても削除しない）。改名時は参照元も必ず同時に更新する -->
    <SectionContainer id="about">
      <SectionFrame
        :marginTop="112"
        :smMarginTop="80"
        :max-width="1260">
        <SimpleList
          :hasLine="false"
          :margin="32"
          :max-width="1080">
          <li>
            <Bg
              :bgcolor="'gray'"
              :radius="28">
              <div :class="s.part">
                <div :class="s.title">群馬県桐生市はこんな産地</div>
                <div :class="s.wrap">
                  <div :class="s.info_intro_text_wrap">
                    <div :class="s.bold">1300年の歴史が息づく織都で、新しい一歩を踏み出しませんか。</div>
                    <div
                      :class="[s.linespaced, s.sp_sm]"
                      class="n2br">
                      群馬県桐生市は、奈良時代から続く織物の都です。この街の最大の強みは、糸の染色から織り・編み、縫製に至るまで、すべての工程がコンパクトなエリアに集まる「産地内一貫生産」の仕組みにあります。高度な分業によって極められた職人技は、世界のトップメゾンからも厚い信頼を寄せられ、「桐生で形にならないものはない」と言わしめるほどです。<br><br>
                      かつて天満宮を起点に町立てされ、日本遺産や重伝建地区にも選ばれた歴史ある街並みには、今もノコギリ屋根の工場や織物蔵が日常の風景として溶け込んでいます。そして現在、この確かな技術と風情ある土壌に惹かれ、移住して自らのファクトリーブランドを立ち上げるクリエイターや、技術の継承に挑む若い世代が次々と集まっています。<br><br>
                      熟練の職人から本物の技を学ぶ就労も、豊かな産地資源を活かした新たな創業も。桐生には、あなたの「つくりたい」を形にする環境と仲間が揃っています。この地で、次のものづくりを共に織りなしていきませんか。
                    </div>
                  </div>
                  <div :class="s.info_intro_img">
                    <img
                    src="/images/detail/about_intro_1.jpg"
                    alt="桐生市に並ぶノコギリ屋根の工場"
                    :class="[s.darken, s.center]">
                    <img
                    src="/images/detail/about_intro_2.jpg"
                    alt="ノコギリ屋根の工場内で稼働する織機"
                    :class="[s.darken, s.center]">
                  </div>
                </div>
              </div>
            </Bg>
          </li>
          <li>
            <Bg :bgcolor="'gray'" :radius="28">
              <div :class="s.part">
                <div :class="s.title">桐生市の産地統計情報</div>
                <div :class="s.info_stat_graphs">
                  <div :class="[s.info_stat_grafs_item, s.info_stat_grafs_item_first]">
                    <div :class="s.info_stat_grafs_item_title_wrap">
                      <div :class="s.info_stat_grafs_item_title">産業大分類の特徴</div>
                      <div :class="s.info_stat_grafs_item_comment_wrap">
                        <p :class="s.info_stat_grafs_item_comment">織物を中心に多様な「製造業」の割合が高く、工場や職人が集い、高い技術力とものづく りの伝統が根付く地域産業の中心地として、地域経済を支えています。</p>
                      </div>
                    </div>
                    <div :class="s.info_stat_grafs_item_img_wrap">
                      <div :class="s.info_stat_grafs_item_graf_wrap">
                        <p :class="s.info_stat_graf_title">企業数(企業単位)2021年</p>
                        <img :class="s.info_stat_grafs_item_img" src="/images/detail/about_info_graf1_1.png" alt="産業大分類の特徴">
                      </div>
                      <div :class="s.info_stat_grafs_item_graf_wrap">
                        <p :class="s.info_stat_graf_title">従業者数(企業単位)2021年</p>
                        <img :class="s.info_stat_grafs_item_img" src="/images/detail/about_info_graf1_2.png" alt="産業大分類の特徴">
                      </div>
                      <p :class="s.info_stat_grafs_item_img_comment">
                        【注記】 平成24年経済センサス-活動調査においては、東日本大震災の影響で、以下の7自治体の調査 は行っていない。
                        福島県楢葉町、福島県富岡町、福島県大熊町、 福島県双葉町、福島県浪江町、福島県葛尾村、福 島県飯舘村
                        令和3年経済センサス-活動調査では、過去の 調査では活用されていなかった「国税庁法人番号 公表サイト」情報を利用して外観からの確認では 把握が困難な事業所を加えた調査名簿を基に調 査が行われた。
                        このため、従来の活動調査よりも幅広に事業所 を捉えており、時系列比較を行う際は十分に留意 が必要である。
                      </p>
                    </div>
                  </div>
                  <div :class="s.info_stat_grafs_item">
                    <div :class="s.info_stat_grafs_item_title_wrap">
                      <div :class="s.info_stat_grafs_item_title">製造業の産業中分類の特徴</div>
                      <div :class="s.info_stat_grafs_item_comment_wrap">
                        <p :class="s.info_stat_grafs_item_comment">製造業の中でも「繊維工業」は特に企業数の割合が高く、長い歴史と伝統に支えられた織物・繊維の集積産地としての強みがあります。</p>
                      </div>
                    </div>
                    <div :class="s.info_stat_grafs_item_img_wrap">
                      <div :class="s.info_stat_grafs_item_graf_wrap">
                        <p :class="s.info_stat_graf_title">企業数(企業単位)2021年</p>
                        <img :class="s.info_stat_grafs_item_img" src="/images/detail/about_info_graf2_1.png" alt="産業大分類の特徴">
                      </div>
                      <div :class="s.info_stat_grafs_item_graf_wrap">
                        <p :class="s.info_stat_graf_title">従業者数(企業単位)2021年</p>
                        <img :class="s.info_stat_grafs_item_img" src="/images/detail/about_info_graf2_2.png" alt="産業大分類の特徴">
                      </div>
                      <p :class="s.info_stat_grafs_item_img_comment">
                        【注記】 従業者とは、当該企業、事業所に所属して働いている全ての人をいう。
                        したがって、 他の会社などの別経営の事業所へ出向又 は派遣している人も含まれる。
                        一方、当該企業、事業所で働いている人 であっても、他の会社などの別経営の事業 所から出向又は派遣されているなど、当該 企業、事業所から賃金・給与(現物給与を 含む。)を支給されていない人は従業者に 含めない。
                        なお、個人経営の事業所の家族従業者 は、賃金・給与を支給されていなくても従業 者としている。
                      </p>
                    </div>
                  </div>
                </div>
                <p :class="s.info_stat_grafs_item_source">出典:総務省「経済センサス-基礎調査」 再編加工、総務省・経済産業省「経済セン サス-活動調査」再編加工</p>
              </div>
            </Bg>
          </li>
          <li>
            <Bg :bgcolor="'gray'" :radius="28">
              <div :class="s.part">
                <div :class="s.title">
                  <span :class="s.title_span">産地発信情報</span>
                  <span :class="s.title_span">（WEBサイト）</span>
                </div>
                <ul :class="s.info_web_list">
                  <li v-for="web_item in web_items" :key="web_item.name" :class="[s.info_web_list_item]">
                    <div :class="s.info_web_list_item_wrap">
                      <img :class="s.info_web_list_item_img" :src="web_item.img" alt="">
                      <spacer :y="3"/>
                      <div :class="[s.bold, s.alignCenter, s.info_web_list_item_title]">
                        <span 
                          v-for="(line, index)  in web_item.title" 
                          :key="index"
                          :class="s.info_web_list_item_title_line"
                        >
                        {{ line }}
                        </span>
                      </div>
                      <spacer :y="3"/>
                    </div>
                    <div :class="s.btn_wrap">
                      <basic-btn
                        :type="'bdr'"
                        :size="'sm'"
                        :width="'fit-content'"
                        :tag="'a'"
                        :link="web_item.link"
                        :openOtherTab="true">詳しく見る</basic-btn>
                    </div>
                  </li>
                </ul>
              </div>
            </Bg>
          </li>
          <li>
            <Bg :bgcolor="'gray'" :radius="28">
              <div :class="s.part">
                <div :class="s.title">交通アクセス</div>
                <div :class="s.traffic">
                  <div :class="s.map">
                    <img src="/images/detail/about_traffic_map.png" alt="" :class="s.darken">
                  </div>
                  <div :class="s.imgs">
                    <img src="/images/detail/about_train.png" alt="" :class="s.darken">
                    <spacer :y="3.5"/>
                    <img src="/images/detail/about_car.png" alt="" :class="s.darken">
                  </div>
                </div>
              </div>
            </Bg>
          </li>
        </SimpleList>
      </SectionFrame>
    </SectionContainer>

    <SectionContainer id="charm">
      <SectionFrame :title="'産地の特長・魅力'">
        <Loader
          :flag="card.loading"
          :mini="false">
          <SimpleList
            :hasLine="false"
            :margin="32"
            v-if="card.cards?.length">
            <BgListItem
              v-for="item in charmsCards"
              :key="item.id"
              :bgcolor="'gray'">
                <ContentListFrame :item="item" />
                <div
                  v-if="item.figure"
                  :class="s.charm_figure">
                  <img
                    :src="item.figure.src"
                    :alt="item.figure.alt"
                    :class="s.charm_figure_img">
                </div>
            </BgListItem>
          </SimpleList>
          <div
            v-else-if="!card.loading"
            :class="s.cards_message">
            <span v-if="card.notFound">読み込みに失敗しました</span>
            <span v-else>該当のコンテンツがありませんでした</span>
          </div>
        </Loader>
      </SectionFrame>
    </SectionContainer>

    <Spacer :y="7.5"/>

    <Interview
      id="interview"
      :category="categoryId" />

  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  Spacer,
  SectionFrame,
  BasicBtn,
  ContentListFrame,
  Bg,
  SectionContainer,
  SimpleList,
  Interview,
  Loader,
  BgListItem,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'support-living',
  components: {
    BgListItem,
    Spacer,
    SectionFrame,
    BasicBtn,
    ContentListFrame,
    Bg,
    SectionContainer,
    SimpleList,
    Interview,
    Loader,
  },
  mixins: [cf],
  data() {
    return {
      reelShowFlag: false,
      // hash付きで流入した直後だけ、データ確定時のスクロール位置補正を有効にするフラグ
      isHashScrollPending: false,
      reels: [
        'DIVdmXfyhdG',
        'DIDNugzSGjF',
        'DFE7sipysKa',
        'DGNH67XSKmJ',
        'DHP4224S7bS',
        'DHdCuMoyQTA',
        'DHdKIEWSyhy',
        'DHxHD2zSLV2',
      ],
      web_items: [
        {
          name: 'kiryu-textile',
          img: '/images/thumbnail-kiryu-textile.png',
          title: ['KIRYU textile', '（桐生織物協同組合）'],
          link: 'https://kiryutextile.com/',
        },
        {
          name: 'kiryu-cci',
          img: '/images/thumbnail-kiryu-cci.png',
          title: ['kiryu craft story', '（桐生商工会議所）'],
          link: 'https://www.kiryucraft.com/',
        },
      ],
      medias: [
        {
          title: '老舗刺繍工房「笠盛」でデザイナーを陰で支える片倉洋一がみつめる次の百年',
          medias: [
            {
              url: '/images/dammy_store.png',
            },
          ],
          buttons: [
            {
              label: '詳細を読む',
              link: 'https://www.fashionsnap.com/article/ksamori-interview1/',
            },
          ],
        },
        {
          title: 'シルクの魅力を伝え、もっと日常に。1300年続く桐生のシルク文化を次世代に繋ぐ！',
          medias: [
            {
              url: '/images/dammy_store.png',
            },
          ],
          buttons: [
            {
              label: '詳細を読む',
              link: 'https://for-good.net/project/1003690',
            },
          ],
        },
      ],
      ig: {
        loading: true,
        notFound: false,
        hashtags: [],
        medias: [],
        tagIndex: 0,
        page: 1,
        limit: 20,
        lastPage: 1,
      },
      card: {
        loading: true,
        notFound: false,
        cards: [],
      },
      // 「産地の特長・魅力」カードに添える図版。カードのorderをキーに紐づける。
      // ※管理画面でカードを並び替えると紐づく先が変わる点に注意。
      // 将来サーバーサイド管理へ移す場合は、ここと charmsCards() の2箇所だけ差し替える。
      charmFigures: {
        1: {
          src: '/images/detail/about_process.jpg',
          alt: '桐生産地の製造工程',
        },
      },
    };
  },

  mounted() {
    if (this.$route.hash) this.isHashScrollPending = true;
    this.getIgHashtags();
    this.getCards();
    this.$nextTick(() => {
      this.reelShowFlag = true;
    });
  },
  computed: {
    ...mapState(['helper']),
    /**
     * 「産地の特長・魅力」カードの種別。
     * むすびすむの about/charms と分離するため専用type。admin側の type='tex-about' と一致させる。
     */
    cardType() {
      return 'tex-about';
    },
    categoryId() {
      return this.helper?.categories?.find((d) => d.name === 'tex-about')?.id || null;
    },
    /** charmsのカードに静的な図版定義をマージして返す */
    charmsCards() {
      return this.adjustCards(this.card.cards, 'charms')
        .map((item) => ({
          ...item,
          figure: this.charmFigures[item.order] || null,
        }));
    },
    isLoading() {
      return this.ig.loading || this.card.loading;
    },
    routeHash() {
      return this.$route.hash;
    },
  },
  watch: {
    routeHash: {
      handler() {
        if (this.$route.name === 'About') this.checkPath();
      },
      deep: true,
    },
    isLoading(loading) {
      // hash付きで流入した直後だけ、データ確定までスクロール位置を補正する
      // （常時実行するとハッシュタグ切替等のロードのたびにスクロールが飛ぶ）
      if (!this.isHashScrollPending) return;
      this.checkPath();
      if (!loading) this.isHashScrollPending = false;
    },
  },
  methods: {
    checkPath() {
      // $route.hashがある場合には、APIで取得するデータが揃った段階でスクロールさせる
      if (this.$route.hash) {
        const id = this.$route.hash.replace('#', '');
        // 保留中のDOM更新で初描画される要素も対象にするため、要素の取得はnextTick内で行う
        this.$nextTick(() => {
          const elem = document.getElementById(id);
          if (!elem) return;
          const rect = elem.getBoundingClientRect();
          const offsetTop = window.pageYOffset + rect.top;
          window.scrollTo({ top: offsetTop });
        });
      } else {
        window.scrollTo({ top: 0 });
      }
    },
    /**
     * 有効な登録ハッシュタグを取得
     */
    getIgHashtags() {
      this.axios({
        method: 'GET',
        url: '/v1/instagram/get/hashtags',
        params: {
          flags: [1],
          order: 'igHashtags.id',
          orderBy: 'desc',
        },
      })
        .then((response) => {
          this.ig.hashtags = response.data.list.data;
          // ハッシュタグを取得してから投稿を取得
          if (this.ig.hashtags.length) this.getIgMedias();
          else this.ig.loading = false;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.ig.loading = false;
          this.ig.notFound = true;
        });
    },

    /**
     * ハッシュタグに連動した投稿を取得
     */
    getIgMedias(refresh = true) {
      if (refresh) {
        // ハッシュタグ切り替え時等に初期化
        this.ig.loading = true;
        this.ig.notFound = false;
        this.ig.medias = [];
        this.ig.page = 1;
        this.ig.lastPage = 1;
      }
      const currentTag = this.ig.hashtags[this.ig.tagIndex];
      this.axios({
        method: 'GET',
        url: '/v1/instagram/get/medias',
        params: {
          page: this.ig.page,
          limit: this.ig.limit,
          hashtag_id: currentTag.id,
          flags: [1],
        },
      })
        .then((response) => {
          this.ig.lastPage = response.data.list.meta.last_page;
          this.shapeMedias(response.data.list.data, refresh);
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.ig.notFound = true;
          this.ig.loading = false;
        });
    },

    /**
     * template内で出力しやすいよう整形
     */
    shapeMedias(responseData, refresh) {
      if (!responseData.length) {
        this.ig.loading = false;
        return;
      }
      const showMedias = [];
      responseData.forEach((row) => {
        const hasMedia = row.ig_media_url || (row.children && row.children[0]);
        if (row.ig_media_type !== 'VIDEO' && hasMedia) {
          // 1枚のみ表示するためキーを統一する
          let mediaUrl = row.ig_media_url || null;
          if (row.children) {
            // children（CAROUSEL_ALBUM）の一枚目がVIDEOの場合もある
            row.children.some((d) => {
              if (d.ig_media_type === 'IMAGE') {
                mediaUrl = d.ig_media_url;
                return true;
              }
              return false;
            });
          }
          const data = {
            id: row.id,
            permalink: row.permalink,
            likeCount: row.like_count || 0,
            mediaUrl,
            mediaId: row.ig_media_id,
            mediaType: row.ig_media_type,
          };
          showMedias.push(data);
        }
      });

      if (refresh) {
        this.ig.medias = showMedias;
      } else {
        this.ig.medias = [...this.ig.medias, ...showMedias];
      }

      this.ig.loading = false;
    },

    /**
     * cards取得
     */
    getCards() {
      const params = {
        flags: [1],
        type: 'tex-about',
        orderBy: 'order',
        order: 'asc',
      };

      this.axios({
        method: 'GET',
        url: '/v1/card/get/list',
        params,
      })
        .then((response) => {
          this.card.cards = response.data.cards.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.card.notFound = true;
        })
        .finally(() => {
          this.card.loading = false;
        });
    },

    /**
     * もっと見るボタン押下
     */
    handleLoadMore() {
      if (this.ig.page < 2) {
        // 2ページ目（40件）まではload more
        this.ig.page += 1;
        this.getIgMedias(false);
      } else {
        // 3ページ目からinstagramの該当hashtagへリンク
        const currentHashtag = this.ig.hashtags[this.ig.tagIndex];
        const url = `https://www.instagram.com/explore/tags/${currentHashtag.ig_hashtag}/`;
        window.open(url, '_blank');
      }
    },

    /**
     * ハッシュタグの切り替え
     */
    changeHashtag(index) {
      this.ig.tagIndex = index;
      this.getIgMedias();
    },
  },
};
</script>

<style lang="scss" module="s">
.part {
  padding: 70px;
  display: flex;
  flex-flow: column;
  align-items: center;
  .title {
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 60px;
  }
  .title_span {
    display: inline-block;
  }
  .wrap {
    gap: 10px;
  }
}

.traffic {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .map {
    width: 50%;
  }
  .imgs {
    width: 45%;
  }
}


.taglist {
  > li {
    flex-shrink: 0;
  }
}

.insta {
  &_label {
    font-weight: 700;
    margin-bottom: 24px;
  }
  &_link {
    overflow: hidden;
    border-radius: 20px;
    position: relative;
    display: block;
    &:hover {
      .insta_item {
        &:before {
          opacity: 1;
        }
      }
      .insta_like_count {
        opacity: 1;
      }
    }
  }
  &_item {
    width: 100%;
    padding-top: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    z-index: 0;
    transition: all .4s;
    &:before {
      content: "";
      opacity: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(black, .6);
      z-index: 1;
    }
  }
  &_like_count {
    position: absolute;
    bottom: .5em;
    right: 1em;
    z-index: 2;
    opacity: 0;
    color: white;
    svg {
      fill: white;
      margin-right: .2em;
    }
  }

  &_account {
    display: flex;
    flex-flow: column;
    align-items: center;
    .name {
      margin-top: 16px;
      word-break: break-all;
    }
  }
}

.darken {
  mix-blend-mode: darken;
}
.center {
  margin: 0 auto;
}
.alignCenter {
  text-align: center;
}
.bold {
  font-weight: 700;
}
.linespaced {
  line-height: 2;
}
.cards_message {
  padding: 48px 0;
  text-align: center;
  color: var(--label-secondary);
}

// カード内の本文・ボタンの下に置く全幅の図版（製造工程図など）
.charm_figure {
  margin-top: 32px;

  &_img {
    width: 100%;
    border-radius: 14px;
  }
}

@include smView {
  .charm_figure {
    margin-top: 24px;
  }
}
.center {
  text-align: center;
}


.info_intro_text_wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info_intro_img {
  margin-top: 24px;
  display: flex;
  align-items: center;
  > * {
    display: block;
    width: calc((100% - 12px) / 2);
    border-radius: 14px;
    &:not(:first-child) {
      margin-left: 12px;
    }
  }
}

.info_stat_graphs {
  display: grid;
  grid-template-columns: 1fr 1fr;;
  gap: 20px;
}

.info_stat_grafs_item {
  display: grid;
  grid-template-rows: subgrid;
  grid-row: span 2;
  gap: 10px;
  background: white;
  border-radius: var(--radius);
  padding: 28px;
}


.info_stat_grafs_item_title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.info_stat_grafs_item_comment {
  font-size: 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.info_stat_grafs_item_img_wrap {
  display: flex;
  flex-direction: column;
  align-content: center;
  gap: 10px;
}

.info_stat_grafs_item_graf_wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info_stat_graf_title {
  font-size: 14px;
  font-weight: bold;
}

.info_stat_grafs_item_img_comment {
  font-size: 9px;
  color: var(--brand-gray);;
}

.info_stat_grafs_item_source{
  font-size: 9px;
  color: var(--brand-gray);
  padding-top: 10px;
}


.info_stat_lists {
  $pdg: 32px;
  display: flex;
  justify-content: center;
  gap: 30px;
  font-size: 14px;
  margin-top: 40px;
  width: 100%;
}

.info_stat_lists_title {
  font-weight: 700;
  text-align: center;
  font-size: 20px;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--label-primary);
  width: 50%;
  margin: 0 auto;
}

.info_stat_lists_item {
  width: calc(50% - 30px);
  text-align: center;
  background-color: white;
  border-radius: var(--radius);
  padding: 28px;
}

.info_stat_list {
  width: fit-content;
  margin: 0 auto 12px;
  padding-top: 8px;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
}

.info_stat_list_item {
  display: flex;
  font-size: 20px;
  gap: 20px;
}

.info_web_list {
  display: flex;
  align-items: center;
  gap: 30px;
  width: 100%;
}

.info_web_list_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: column;
  width: calc(50% - 30px);
}

.info_web_list_item_img {
  width: 100%;
  max-width: 396px;
}

.info_web_list_item_title_line {
  display: block;
}

@include mdView {
  .part {
    padding: 32px;
  }
  .info_stat_grafs_item {
    padding: 20px;
  }
}

@include smView {
  .info_stat_graphs {
    display: block;
  }

  .info_stat_grafs_item {
    display: block;
    width: 100%;
    padding: 28px;
  }

  .info_stat_grafs_item_first {
    margin-bottom: 20px;
  }

  .part {
    padding: 32px 20px;
    .sp_sm {
      font-size: 14px;
    }
    .traffic {
      display: block;
      > * {
        width: 100%;
      }
      .imgs {
        margin-top: 20px;
        > * {
          margin: 0 auto;
        }
      }
    }
  }

  .info_stat {
    display: block;
    .item, .climate {
      width: 100%;
    }
    .climate {
      margin-top: 36px;
    }
  }

  .taglist {
    margin-left: -20px;
    padding-left: 20px;
  }

  .insta {
    &_link {
      border-radius: 14px;
    }
  }

  .info_intro_img {
    flex-direction: column;
    > * {
      width: 100%;
      border-radius: 14px;
      &:not(:first-child) {
        margin-left: 0px;
        margin-top: 12px;
      }
    }
  }

  .info_web_list {
    gap: 15px;
  }

  .info_web_list_item {
    width: calc(50% - 15px);
  }

  .info_web_list_item_title {
    font-size: 15px;
  }
}
</style>
